import axios from 'axios';
import { OrderListItem } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/order-list-item.type';

// GET
// ewosapi/v1/order/my-supply-plan?customerErpId={customerErpId}&siteErpId={siteErpId}

export const getOrders = async (customerErpId: string, siteErpId: string) => {
  const res = await axios.get<OrderListItem[]>(
    `ewosapi/v1/order/my-supply-plan?customerErpId=${customerErpId}&siteErpId=${siteErpId}`
  );
  return res.data;
};
